import type { Verdict } from './types.ts';
import { decidingStage, gameVerdict, stageVerdict } from './verdict.ts';

/** The rule-based verdict service, the one plugin-shared-verdict registers. */
export const ruleVerdict: Verdict = { game: gameVerdict, stage: stageVerdict, decidingStage };
